<template>
  <div>
    <Problem @emitResult="callback" />
  </div>
</template>

<script>
export default {
  components: {
    Problem: () => import('@/components/signup/Problem.vue'),
  },
  methods: {
    async callback(result) {
      // if (result === true) {
      //   return await this.$router.push(`/auth/accounts/sales`)
      // }
    },
  },
}
</script>

<style></style>
